import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import Forces from '../common/Forces';

export default class SomeBitmapMoving {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    this.scene = scene;

    this.bmp = null;

    this.completeCallback = null;
    this.fade = false;
    this.rotate = false;

    this.mass = 1.0;
    this.gravity = 0;
    this.k = 0.0;

    this.pos = new Phaser.Math.Vector2();
    this.vel = new Phaser.Math.Vector2();
    this.lifetime = 2;
    this.age = 0;
    this.halflife = 0;

    this.gravityForce = new Phaser.Math.Vector2();
    this.dragForce = new Phaser.Math.Vector2();
    this.totalForce = new Phaser.Math.Vector2();

    Forces.constantGravity(this.mass, this.gravity, this.gravityForce);
  }

  reset (img, vx, vy, lifetime = 10, destX, destY) {
    this.pos.x = img.x;
    this.pos.y = img.y;
    this.vel.x = vx;
    this.vel.y = vy;
    this.lifetime = lifetime;
    this.halflife = lifetime / 2;
    this.age = 0;
    this.alpha = 1;
    this.scale = 0.8;

    this.destX = destX;
    this.destY = destY;

    this.workingWidth = img.width;
    this.workingHeight = img.height;

    this.bmp = img;

    this.update();

    this.bmp.alpha = img.alpha;
    this.bmp.angle = img.angle;
    this.bmp.scaleX = img.scaleX;
    this.bmp.scaleY = img.scaleY;
  }

  update () {
    this.bmp.x = this.pos.x;
    this.bmp.y = this.pos.y;
  }

  move (dt) {
    this.pos.add({ x: this.vel.x * dt, y: this.vel.y * dt });
    if (this.rotate) this.bmp.angle += this.vel.x * dt;
  }

  updateAccel () {
    this.totalForce.multiply({ x: 1 / this.mass,y: 1 / this.mass });
  }

  updateVelocity (dt) {
    this.vel.add({ x: this.totalForce.x * dt,y: this.totalForce.y * dt });
  }

  tick (dt) {
    this.move(dt);
    this.updateAccel();
    this.updateVelocity(dt);

    this.age += dt;

    if (this.fade && this.age > this.halflife) {
      this.bmp.alpha -= 0.8 * dt;
    }
    return this.age < this.lifetime;
  }
}